import { QuizTabStyles } from './tabs.style';
import { TabProps } from './types';

// --------------------------------------------------------------------------

const {
  TabsContent,
  QuizContainer,
  ImageContainer,
  Image,
  ContentText,
  ContentLink,
  ImageWrapper,
} = QuizTabStyles;

// --------------------------------------------------------------------------

const QuizTab = ({
  id,
  image,
  text,
  link,
  className,
  ctaAriaLabel,
  onClick,
}: TabProps) => {
  return (
    <TabsContent className={className} value={id}>
      <QuizContainer>
        {image && (
          <ImageContainer>
            <ImageWrapper>
              <Image
                src={image?.src}
                alt={image?.alt}
                height={image?.height}
                width={image?.width}
              />
            </ImageWrapper>
          </ImageContainer>
        )}
        <ContentText as={'p'} variant="text-body-reg-sm">
          {text}
        </ContentText>
        {!!link?.href && (
          <ContentLink
            href={link.href}
            target="_blank"
            aria-label={ctaAriaLabel}
            onClick={onClick}
          >
            {link.text}
          </ContentLink>
        )}
      </QuizContainer>
    </TabsContent>
  );
};

// --------------------------------------------------------------------------

export default QuizTab;
